import axiosIns from '@/api/axios'

export const GET_PROJECT_ROLE = (args) => {
    return axiosIns.get('/master-data/project-role', args)
}

